(function () {
  angular.module("akitabox.workOrder.buildingList", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.workOrder",
  ]);
})();
